import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filedrop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Drop your files here", -1)),
    _createElementVNode("div", {
      onDragenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileHover = true)),
      onDragleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileHover = false)),
      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["stop","prevent"])),
      class: _normalizeClass(["filedrop-receive", { 'filedrop-receive-hover': _ctx.fileHover }])
    }, null, 34)
  ]))
}